// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// import HelloController from "./hello_controller"
// application.register("hello", HelloController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import ChatChartController from "./chat_chart_controller"
application.register("chat-chart", ChatChartController)

import AutoScrollController from "./auto_scroll_controller"
application.register("auto-scroll", AutoScrollController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)
